var _defs, _path, _path2, _path3, _path4, _path5, _path6, _path7, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgZw(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 1200,
    height: 600,
    viewBox: "0 0 25200 12600",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "a"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 0h63v63H0z"
  })))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#006400",
    d: "M0 0h25200v12600H0z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#ffd200",
    d: "M200 1800h25000v9000H200z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "#d40000",
    d: "M200 3600h25000v5400H200z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M200 5400h25000v1800H200z"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    clipPath: "url(#a)",
    stroke: "#000",
    strokeWidth: 3,
    d: "M42 31.5 0 63V0z",
    transform: "scale(200)"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M8400 6300 0 12600V0z"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    fill: "#d40000",
    d: "m3200 3169.5 1645.8 5065.3L537 5104.3h5326L1554.2 8234.8z"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    stroke: "#000",
    strokeLinejoin: "round",
    strokeLinecap: "round",
    strokeWidth: 38
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#ffd200",
    d: "M2290 4580c-18-45-15-95 8-138 23-42 65-72 113-80 51-9 102-12 154-11 49-76 131-125 221-132 90-6 178 30 238 98 71 81 113 183 122 290l37 464 1412 1105a86 86 0 0 1-76 150l-59-17c-227 141-395 387-428 651l-85 672H2454l-198-769c-71-86-81-207-25-303 73-125 161-241 262-345 66-66 96-160 83-253-14-92-21-185-22-278-1-77 16-154 49-223l-19-694c-3-82-48-157-119-197z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m2465 4570 167-10m-29 901 580-390m232 1167c229 64 372 45 439-101m-852-566c-62 179 50 338 200 381l1258 357m-2040 631c-47-184 21-513 312-650 135-63 179-201 180-318 0-44 1-95 64-120m-720 1011 44-107c21 79 64 137 120 184 31-65 58-131 81-198 26 52 47 123 65 194-4-161 81-279 193-329l434-193c141-63 276-188 307-378m742 460H3008m-727 464h1751m-1346 381h1297m-1428-381 131 381v291m-63-509 128-128 128 128 128-128 128 128 128-128 128 128 128-128 128 128 128-128 128 128 124-124m-1366 269 90-90 128 128 128-128 128 128 128-128 128 128 128-128 128 128 128-128 128 128 97-97"
  }), /*#__PURE__*/React.createElement("circle", {
    r: 76,
    cx: 2799,
    cy: 4459
  }), /*#__PURE__*/React.createElement("circle", {
    r: 145,
    cx: 3139,
    cy: 6730
  }), /*#__PURE__*/React.createElement("circle", {
    r: 145,
    cx: 3714,
    cy: 6730
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgZw);
export default __webpack_public_path__ + "static/media/zw.b0c4746bad8c76c2e5d3e3dca2c7cdff.svg";
export { ForwardRef as ReactComponent };